/**
 * This code is adapted from the zod-vue-i18n library
 * @see https://github.com/volverjs/zod-vue-i18n/blob/develop/src/utils/index.ts
 */

export function joinValues<T extends unknown[]>(array: T, separator = " | "): string {
  return array.map((val) => (typeof val === "string" ? `'${val}'` : val)).join(separator);
}
